var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.64286,
    height: 3.64286,
    fill: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6.67969,
    width: 3.64286,
    height: 3.64286,
    fill: "#909090"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 13.3555,
    width: 3.64286,
    height: 3.64286,
    fill: "#909090"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.28613,
    width: 3.64286,
    height: 3.64286,
    fill: "#909090"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.28613,
    y: 6.67969,
    width: 3.64286,
    height: 3.64286,
    fill: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.28613,
    y: 13.3555,
    width: 3.64286,
    height: 3.64286,
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.bc2bbe6cd4920d8c4a92a2041bad0c37.svg";
export { ForwardRef as ReactComponent };